import { Button } from "@/components/ui/button";
import { PencilSimple } from "@phosphor-icons/react";

/**
 * Tab body: "Assignments" — every active publisher × campaign pair.
 * The Locales cell is a button that opens a per-pub tracker-URL
 * dialog so admin can quickly grab the locale-specific links.
 */
export default function AssignmentsTab({
  assignments, loading,
  onViewLocales, onEditAssignment, onRevoke,
}) {
  return (
    <div className="border border-slate-200 rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50">
          <tr className="border-b border-slate-200">
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Publisher</th>
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Sub ID</th>
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Campaign</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Shave</th>
            <th className="text-center px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Locales</th>
            <th className="text-center px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Above $0.27</th>
            <th className="text-center px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Status</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Assigned</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Actions</th>
          </tr>
        </thead>
        <tbody>
          {assignments.map((a) => (
            <tr key={a.id} className="border-b border-slate-100 hover:bg-slate-50">
              <td className="px-4 py-3 text-slate-900">{a.publisher_email}</td>
              <td className="px-4 py-3 font-mono text-xs text-slate-600">{a.publisher_sub_id || "—"}</td>
              <td className="px-4 py-3">{a.campaign_label}</td>
              <td className="px-4 py-3 text-right font-mono text-xs">
                {(a.shave_cents ?? 0.01) === 0 ? "—" : `$${(a.shave_cents ?? 0.01).toFixed(2)}`}
              </td>
              <td className="px-4 py-3 text-center">
                <button
                  type="button"
                  onClick={() => onViewLocales(a)}
                  className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-[#002FA7]/10 text-[#002FA7] hover:bg-[#002FA7]/20"
                  data-testid={`sn-locales-${a.id}`}
                >
                  {(a.enabled_locales || ["amazon.com"]).length} locale{(a.enabled_locales || ["amazon.com"]).length === 1 ? "" : "s"}
                </button>
              </td>
              <td className="px-4 py-3 text-center">
                <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${
                  a.passthrough_above_cap ? "bg-blue-50 text-blue-700" : "bg-slate-100 text-slate-500"
                }`}>
                  {a.passthrough_above_cap ? "Pass-through" : "Cap $0.27"}
                </span>
              </td>
              <td className="px-4 py-3 text-center">
                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                  a.status === "active" ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"
                }`}>{a.status}</span>
              </td>
              <td className="px-4 py-3 text-right text-xs text-slate-500">
                {a.assigned_at ? new Date(a.assigned_at).toLocaleDateString() : "—"}
              </td>
              <td className="px-4 py-3 text-right">
                {a.status === "active" && (
                  <div className="flex justify-end gap-1">
                    <Button size="sm" variant="ghost" onClick={() => onEditAssignment(a)} data-testid={`sn-edit-shave-${a.id}`}>
                      <PencilSimple size={14} />
                    </Button>
                    <Button size="sm" variant="ghost" className="text-rose-600 hover:bg-rose-50" onClick={() => onRevoke(a)} data-testid={`sn-revoke-${a.id}`}>
                      Revoke
                    </Button>
                  </div>
                )}
              </td>
            </tr>
          ))}
          {assignments.length === 0 && !loading && (
            <tr><td colSpan={8} className="px-4 py-6 text-center text-sm text-slate-400">No assignments yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
